const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * @function evaluate - evaluates a conditional value `test`,
 * and if it is truthy, it returns the value property.
 */

const evaluate = async (format, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    test,
    onTrue,
    onFalse
  } = format;
  const testResult = await evaluateSource(test, content, parentContentPath, transientContext, nativeFunctions);
  if (testResult === undefined) {
    return undefined;
  }
  if (onTrue !== undefined && testResult === true) {
    return evaluateSource(onTrue, content, parentContentPath, transientContext, nativeFunctions);
  }
  if (onFalse !== undefined && testResult === false) {
    return evaluateSource(onFalse, content, parentContentPath, transientContext, nativeFunctions);
  }
  return undefined;
};
module.exports = {
  evaluate
};